<template>
  <div>
    <button @click="isOpen = !isOpen" class="button">
      {{ content.title }}
      <font-awesome-icon v-show="!isOpen" icon="fa-solid fa-plus" class="button-icon" />
      <font-awesome-icon v-show="isOpen" icon="fa-solid fa-minus" class="button-icon" />
    </button>
    <collapse-transition>
      <div v-show="isOpen" class="inner">
        <div v-for="category in content.categories" :key="category.name">
          <p v-show="category.name !== null || category.name !== ''" class="category-label">
            {{ category.name }}
          </p>
          <!-- <dl v-for="item in category.items" :key="item.key" class="item-list">
            <dt class="item-key">{{ item.key }}</dt>
            <dd class="item-value">{{ item.value }}</dd>
          </dl> -->
          <table class="table table-striped">
            <tbody>
              <tr v-for="item in category.items" :key="item.key">
                <td class="item-key">{{ item.key }}</td>
                <td class="item-value"><span v-html="item.value"></span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </collapse-transition>
  </div>
</template>

<script>
import { CollapseTransition } from '@ivanv/vue-collapse-transition';

/*
fontawusome
https://fontawesome.com/docs/web/use-with/vue/add-icons
*/
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
library.add(faPlus, faMinus);

export default {
  components: {
    CollapseTransition,
    FontAwesomeIcon,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  created() {
    this.isOpen = this.isInitialOpen;
  },
  props: {
    content: {
      type: Object,
      default: null,
      required: true,
    },
    isInitialOpen: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  border: none; /* 枠線を消す */
  outline: none; /* クリックしたときに表示される枠線を消す */
  background: transparent; /* 背景の灰色を消す */

  position: relative;
  width: 100%;
  padding: 0.8rem 0.8rem 0.8rem 0.8rem;
  margin: 0 0 0.5rem 0;
  background-color: #eee;
  color: #000;
  text-align: left;
  font-size: 0.9rem;
  cursor: pointer;

  &-icon {
    /* https://yuyauver98.me/btn-deploy-right-icon/ */
    position: absolute;
    top: 50%;
    right: 1rem; /*右からの距離*/
    width: 20px; /*アイコンの横幅指定*/
    transform: translateY(-50%); /*この指定で上下中央に*/
  }
}

.inner {
  padding: 0.5rem 1rem 0.5rem 1rem;
}

.category-label {
  color: #7a7a7a;
  font-size: 1.2rem;
}

.item-table {
  border: 0px none;
}

.item-key {
  width: 30%;
  padding: 1rem 0.5rem 1rem 1rem;

  font-size: 0.8rem;
  font-weight: bold;
  white-space: pre-wrap;
}

.item-value {
  width: 70%;
  padding: 1rem 0.5rem 1rem 1rem;

  font-size: 0.8rem;
  white-space: pre-wrap;
}
</style>
